import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QualityCheckService {
  approveOrRejectType: string;
  userData: any;
  historyReportList = [];
  private messageSource = new BehaviorSubject(0);
  currentMessage = this.messageSource.asObservable();
  searchForm: any;
  searchArr: any[];
  assignControl: any;
  qcOrFqc: any;
  backFlag = false;
  constructor(private http: HttpClient) {
    this.userData = JSON.parse(sessionStorage.getItem('user_data'));
  }
  changeMessage(message: number) {
    this.messageSource.next(message);
  }
  getFQcDetails(SearchData): Observable<any> {
    const dataUrl = 'Qc/GetFQcDetails';
    return this.http.post<any>(dataUrl, SearchData, { observe: 'response' as 'body' });
  }
  GetIQCFinalCompDet(loginUserDetVm): Observable<any> {
    const dataUrl = 'Qc/GetIQCFinalCompDet';
    return this.http.post<any>(dataUrl, loginUserDetVm, { observe: 'response' as 'body' });
  }
  // GetQcApprovedRejectedDetails(loginUserDetVm) {
  //   const dataUrl = 'Qc/GetQcApprovedRejectedDetails';
  //   return this.http.post<any>(dataUrl, loginUserDetVm);
  // }
  GetIQcApprovedList(loginUserDetVm): Observable<any> {
    const dataUrl = 'Qc/GetIQcApprovedList';
    return this.http.post<any>(dataUrl, loginUserDetVm, { observe: 'response' as 'body' });
  }
  GetIQcRejectedList(loginUserDetVm): Observable<any> {
    const dataUrl = 'Qc/GetIQcRejectedList';
    return this.http.post<any>(dataUrl, loginUserDetVm, { observe: 'response' as 'body' });
  }
  GetFQcApprovedList(loginUserDetVm): Observable<any> {
    const dataUrl = 'Qc/GetFQcApprovedList';
    return this.http.post<any>(dataUrl, loginUserDetVm, { observe: 'response' as 'body' });
  }
  GetFinalReportNotSentList(loginUserDetVm): Observable<any> {
    const dataUrl = 'Qc/GetFinalReportNotSentList';
    return this.http.post<any>(dataUrl, loginUserDetVm, { observe: 'response' as 'body' });
  }
  GetIQCPartialDetails(loginUserDetVm): Observable<any> {
    const dataUrl = 'Qc/GetIQCPartialDetails';
    return this.http.post<any>(dataUrl, loginUserDetVm);
  }
  GetFQcRejectedList(loginUserDetVm): Observable<any> {
    const dataUrl = 'Qc/GetFQcRejectedList';
    return this.http.post<any>(dataUrl, loginUserDetVm, { observe: 'response' as 'body' });
  }
  addQcOwner(verificationDetails) {
    const dataUrl = 'Qc/AssignQcOwner';
    return this.http.post<any>(dataUrl, verificationDetails);
  }
  QcApprove(QcApproveVm) {
    const dataUrl = 'Qc/QcApprove';
    return this.http.post<any>(dataUrl, QcApproveVm);
  }
  FinalQCApprovalSentToClientMail(QcApproveVm) {
    const dataUrl = 'Qc/FinalQCApprovalSentToClientMail';
    return this.http.post<any>(dataUrl, QcApproveVm);
  }
  QcApproveRemarks(QcApproveVm) {
    const dataUrl = 'Qc/QcApproveRemarks';
    return this.http.post<any>(dataUrl, QcApproveVm);
  }
  GetScreeningDocumentClientPolicy(screeningId, clientId, screeningCompId, finalQcFlag) {
    const dataUrl = 'Qc/GetScreeningDocumentClientPolicy?screeningId=' + screeningId + '&clientId='
      + clientId + '&screeningCompId=' + screeningCompId + '&finalQcFlag=' + finalQcFlag;
    return this.http.get<any>(dataUrl);
  }
  GetQcErrorType(): Observable<any> {
    const dataUrl = 'Qc/GetQcErrorType';
    return this.http.get<any>(dataUrl);
  }
  GetQcComponentHistory(screeningId) {
    const dataUrl = 'Qc/GetQcComponentHistory?screeningId=' + screeningId;
    return this.http.get<any>(dataUrl);
  }
  GetColorSatus(clientId){
    const dataUrl ='Verification/GetClientColorStatus?ClientId=' +clientId;
    return this.http.get<any>(dataUrl);
  }
  GetRedColorComponent(screeningId) {
    const dataUrl = 'Qc/GetRedColorComponent?screeningId=' + screeningId;
    return this.http.get<any>(dataUrl);
  }
  UpdateRedColorCodeComp(editRedCompData){
    const dataUrl = 'Qc/UpdateRedColorCodeComp';
    return this.http.post<any>(dataUrl,editRedCompData);
  }
  GetIndividualQCReportDocument(screeningCompId, loggedIn) {
    const dataUrl = 'Qc/GetIndividualQCApprovedReportDocument?screeningCompId=' + screeningCompId + '&loggedIn=' + loggedIn;
    return this.http.get<any>(dataUrl);
  }
  GetVerizonReportDocument(clientRefNo, loggedIn) {
    const dataUrl = 'Qc/GetVerizonReportDocument';
    return this.http.post<any>(dataUrl, { clientRefNo: clientRefNo, loggedIn: loggedIn });
  }
  GetVerizonReportWordDocument(clientRefNo, loggedIn) {
    const dataUrl = 'Qc/GetVerizonReportWordDocument';
    return this.http.post<any>(dataUrl, { clientRefNo: clientRefNo, loggedIn: loggedIn });
  }
  UploadVerizonDefaultEmploymentAnnexure(clientRefNo: string, file: File) {
    const dataUrl = 'Qc/UploadVerizonDefaultEmploymentAnnexure';
    const formData = new FormData();
    formData.append('ClientRefNo', clientRefNo);
    formData.append('AnnexureImage', file, file.name);
    return this.http.post<any>(dataUrl, formData);
  }
  GetFinalQCReportDocument(screenName, screeningId, loggedIn) {
    const dataUrl = 'Qc/GetFinalQCApprovedReportDocument?screenName=' + screenName + '&screeningId=' + screeningId + '&loggedIn=' + loggedIn;
    return this.http.get<any>(dataUrl);
  }
  GetSRReportDocument(screenName, screeningId, loggedIn, reportDocId) {
    const dataUrl = 'Qc/GetSRReportDocument?screenName=' + screenName + '&screeningId=' + screeningId + '&loggedIn=' + loggedIn + '&reportDocId=' + reportDocId;
    return this.http.get<any>(dataUrl);
  }
  QcReject(qcReject) {
    const dataUrl = 'Qc/QcReject';
    return this.http.post<any>(dataUrl, qcReject);
  }
  RejectedCompQcApproval(screeningCompId: number, loggedIn: number) {
    const dataUrl = 'Qc/RejectedCompQcApproval?screeningCompId=' + screeningCompId + '&loggedIn=' + loggedIn;
    return this.http.post<any>(dataUrl, null);
  }
  // Individual QC Approved Report Details
  GetIndividualQCApprovedReportDetails(userData): Observable<any> {
    const dataUrl = 'Qc/GetIndividualQCApprovedReportDetails';
    return this.http.post<any>(dataUrl, userData, { observe: 'response' as 'body' });
  }
  // Verizon Report Details
  GetVerizonReportDetails(userData): Observable<any> {
    const dataUrl = 'Qc/GetVerizonReportDetails';
    return this.http.post<any>(dataUrl, userData, { observe: 'response' as 'body' });
  }
  // <!-- Added By Megala - For (Sprint 27) -->
  saveClientCustom(clienCustomVal,loggedId):Observable<any>{
    const dataUrl = 'Qc/SaveScreeningCustomFields?loggedIn='+loggedId;
    return this.http.post<any>(dataUrl, clienCustomVal);
  }
  SaveReportCandidateDetails(reportCandidateDetVm):Observable<any> {
    const dataUrl = 'Qc/SaveReportCandidateDetails';
    return this.http.post<any>(dataUrl, reportCandidateDetVm);
  }
  GetFinalQCApprovedReportDetails(userData): Observable<any> {
    const dataUrl = 'Qc/GetFinalQCApprovedReportDetails';
    return this.http.post<any>(dataUrl, userData, { observe: 'response' as 'body' });
  }
  GetInterimReportDetails(userData): Observable<any> {
    const dataUrl = 'Qc/GetInterimReportDetails';
    return this.http.post<any>(dataUrl, userData, { observe: 'response' as 'body' });
  }
  // CR VTS2/2026/EN/00 - Generate Interim Report screen: separate from GetInterimReportDetails above
  // (that stays as the pre-existing "pending" grid, untouched). Lists cases approved from the
  // Interim QC Approval screen.
  GetInterimApprovedReportDetails(userData): Observable<any> {
    const dataUrl = 'Qc/GetInterimApprovedReportDetails';
    return this.http.post<any>(dataUrl, userData, { observe: 'response' as 'body' });
  }
  GetSRReportDetails(logginId, applicationId): Observable<any> {
    const dataUrl = 'Qc/GetSRReportDetails?logginId=' + logginId + '&applicationId=' + applicationId;
    return this.http.get<any>(dataUrl);
  }
  GetSupplementaryReportDetails(userData) {
    const dataUrl = 'Qc/GetSupplementaryReportDetails';
    return this.http.post<any>(dataUrl, userData, { observe: 'response' as 'body' });
  }
  GetQcDetails(countData): Observable<any> {
    const dataUrl = 'DashBoard/GetDashBoardDetails';
    return this.http.post<any>(dataUrl, countData);
  }
  GetDaywiseActivityCount(dateRange) {
    const dataUrl = 'DashBoard/GetDaywiseActivityCount';
    return this.http.post<any>(dataUrl, dateRange);
  }
  GetDateWiseList(dateRange) {
    const dataUrl = 'DashBoard/GetDateWiseList';
    return this.http.post<any>(dataUrl, dateRange);
  }
  // VP
  GetReportGeneratedHistoryDetails(screeName: string, candidateId: number) {
    const dataUrl = 'QC/GetReportGeneratedHistoryDetails?screenName=' + screeName + '&candidateId=' + candidateId;
    return this.http.get<any>(dataUrl);
  }
  getIqcDetails(SearchData) {
    const dataUrl = 'Qc/GetIqcDetails';
    return this.http.post<any>(dataUrl, SearchData, { observe: 'response' as 'body' });
  }
  // CR VTS2/2026/EN/00 - Interim QC Pending (cases missing an associate/employee ID)
  GetInterimQcPendingList(SearchData): Observable<any> {
    const dataUrl = 'Qc/GetInterimQcPendingList';
    return this.http.post<any>(dataUrl, SearchData, { observe: 'response' as 'body' });
  }
  getSubCheckDetails(SearchData) {
    const dataUrl = 'Qc/GetQCSubCheckDetails';
    return this.http.post<any>(dataUrl, SearchData, { observe: 'response' as 'body' });
  }
  getIQcDropdownDetails(loginUserDetVm: any) {
    const dataUrl = 'Qc/GetIQcDropdownDetails';
    return this.http.post<any>(dataUrl, loginUserDetVm);
  }

  getSubCheckDropdownDetails(loginUserDetVm: any) {
    const dataUrl = 'Qc/GetSubCheckDropdownDetails';
    return this.http.post<any>(dataUrl, loginUserDetVm);
  }
  getFqcPendingDropdownDetails(loginUserDetVm: any) {
    const dataUrl = 'Qc/GetFqcPendingDropdownDetails';
    return this.http.post<any>(dataUrl, loginUserDetVm);
  }
  getIQCFinalCompDetDropDown(loginUserDetVm: any) {
    const dataUrl = 'DropDown/GetIQCFinalCompDetDropDown';
    return this.http.post<any>(dataUrl, loginUserDetVm);
  }
  GetQCHistoryReportDetails(screenName: string, id: number) {
    this.GetReportGeneratedHistoryDetails(screenName, id).subscribe(resp => {
      if (resp) {
        this.historyReportList = resp;
      }
    });
  }
  UpdateClosedDate(QCCloseDatevm) {
    const dataUrl = 'Qc/UpdateCloseDate';
    return this.http.post<any>(dataUrl, QCCloseDatevm);
  }
  GetAdditionalFeeDetails(screeningCompId: number, screeningId: number): Observable<any> {
    const dataUrl = 'Qc/GetAdditionalFeeDetails?screeningCompId=' + screeningCompId + '&screeningId=' + screeningId;
    return this.http.get<any>(dataUrl);
  }
  GetReportType(): Observable<any> {
    const dataUrl = 'Qc/GetReportType';
    return this.http.get<any>(dataUrl);
  }
  GetModifyInterimReportStatus(clientId?: number): Observable<any> {
    const dataUrl = 'Qc/GetModifyInterimReportStatus?clientId=' + clientId;
    return this.http.get<any>(dataUrl);
  }
}
